import { apiClient } from '@/core/api/client';
import { TaskDetailsResponse, TaskCommentsResponse, CommentResponse } from '../types/task.types';

export const commentsApi = {
  getTaskDetails: async (taskId: string): Promise<TaskDetailsResponse> => {
    return apiClient.get(`/api/admin/mes-taches/${taskId}/details`);
  },

  getTaskComments: async (taskId: string): Promise<TaskCommentsResponse> => {
    return apiClient.get(`/api/admin/mes-taches/${taskId}/comments`);
  },

  addComment: async (taskId: string, message: string): Promise<CommentResponse> => {
    return apiClient.post(`/api/admin/mes-taches/${taskId}/comments`, { message });
  },

  updateComment: async (commentId: string, message: string): Promise<CommentResponse> => {
    return apiClient.put(`/api/admin/mes-taches/comments/${commentId}`, { message });
  },

  deleteComment: async (commentId: string): Promise<{ success: boolean }> => {
    return apiClient.delete(`/api/admin/mes-taches/comments/${commentId}`);
  }
};